require.register("app/restaurant/supplier/DeliveryModal", function(exports, require, module){
  $0
  
});

